<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <overdue-moneyboxes-report></overdue-moneyboxes-report>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <data-quality-report></data-quality-report>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <segment-breakdown-report></segment-breakdown-report>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <trend-report></trend-report>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <user-performance-report></user-performance-report>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OverdueMoneyboxesReport from './OverdueMoneyboxesReport.vue'
import DataQualityReport from './DataQualityReport.vue'
import SegmentBreakdownReport from './SegmentBreakdownReport.vue'
import TrendReport from './TrendReport.vue'
import UserPerformanceReport from './UserPerformanceReport.vue'

export default {
  components: {
    OverdueMoneyboxesReport,
    DataQualityReport,
    SegmentBreakdownReport,
    TrendReport,
    UserPerformanceReport,
  },
}
</script>
